import {
  ArrayInput,
  ChipField,
  Create,
  DatagridConfigurable,
  DateInput,
  DeleteButton,
  Edit,
  EditButton,
  FilterButton,
  FilterForm,
  FunctionField,
  Labeled,
  List,
  Pagination,
  ReferenceField,
  ReferenceInput,
  SelectColumnsButton,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  TextField,
  TextInput,
  useNotify,
} from 'react-admin'
import { Stack } from '@mui/material'
import React from 'react'
import { AppContext, useAppContext } from '../modules/app-context'
import { changeField, changeFieldValues } from '~/utils/errorsHandler'

export const ContentTypes = () => {
  return (
    <List pagination={<PostPagination />}>
      <ListToolbar />
      <DatagridConfigurable>
        <TextField label="ID" source="id" />
        <TextField label="Название" source="name" />
        <FunctionField
          source="settings"
          label="Настройки"
          render={e =>
            e.settings
              ? Object.entries(e.settings)
                .map(([key, value]) => `${key}: ${value}`)
                .join('; ')
              : null
          }
        />
        <TextField label="Символьный код" source="symbolCode" />
        <ReferenceField
          source="applicationId"
          reference="applications"
          label="Приложение"
        >
          <TextField source="name" />
        </ReferenceField>
        <EditButton />
        <DeleteButton />
      </DatagridConfigurable>
    </List>
  )
}
const CheckNameValue = (value, allValues, props) =>
  allValues.name ? undefined : 'Введите название'
const CheckCodeValue = (value, allValues, props) =>
  allValues.symbolCode ? undefined : 'Введите код'
const CheckApplicationValue = (value, allValues, props) =>
  allValues.applicationId ? undefined : 'Выберите приложение'
// Форма редактирования сущности
export const ContentTypeEdit = () => {
  const { applicationId } = useAppContext()
  return (
    <Edit title="Изменение типа свойства сущности контента">
      <SimpleForm>
        <Labeled label="Id">
          <TextInput label="" source="id" readOnly />
        </Labeled>
        <Labeled label="Название">
          <TextInput label="" source="name" validate={CheckNameValue} />
        </Labeled>
        <Labeled label="Настройки">
          <ArrayInput label="" source="settings">
            <SimpleFormIterator inline>
              <TextInput
                label=""
                source="name"
                helperText="Содержит только названия"
              />
              <TextInput
                label=""
                source="value"
                helperText="Значение может быть любое"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </Labeled>
        {applicationId ? (
          <Labeled label="Приложение" sx={{ fontSize: 21 }}>
            <ReferenceField source="applicationId" reference="applications">
              <ChipField source="name" size="small" />
            </ReferenceField>
          </Labeled>
        ) : (
          <Labeled label="Список приложений*" sx={{ fontSize: 21 }}>
            <ReferenceInput source="applicationId" reference="applications">
              <SelectInput
                label=""
                source="applications"
                optionValue="id"
                optionText="name"
                validate={CheckApplicationValue}
              />
            </ReferenceInput>
          </Labeled>
        )}
        <Labeled label="Символьный код">
          <TextInput label="" source="symbolCode" readOnly />
        </Labeled>
        <Labeled label="Дата создания">
          <TextInput label="" source="createdAt" readOnly />
        </Labeled>
        <Labeled label="Дата обновления">
          <TextInput label="" source="updatedAt" readOnly />
        </Labeled>
      </SimpleForm>
    </Edit>
  )
}

// Форма создания сущности
export const ContentTypeCreate = () => {
  const { applicationId } = useAppContext()
  const notify = useNotify()
  const onError = error => {
    let obj = JSON.parse(error.request.responseText).message.reduce(
      (acc, { name, value }) => ({ ...acc, [name]: value })
    )
    notify(
      `${changeField(obj.field)}: ${changeFieldValues(
        obj.field,
        String(obj.value)
      )}`,
      { type: 'error' }
    )
  }
  return (
    <Create
      mutationOptions={{ onError }}
      title="Создание типа свойства сущности контента"
    >
      <SimpleForm
        defaultValues={{
          applicationId: applicationId,
        }}
      >
        <Labeled label="Название">
          <TextInput label="" source="name" validate={CheckNameValue} />
        </Labeled>
        <Labeled label="Настройки">
          <ArrayInput label="" source="settings">
            <SimpleFormIterator inline>
              <TextInput
                label=""
                source="name"
                helperText="Содержит только названия"
              />
              <TextInput
                label=""
                source="value"
                helperText="Значение может быть любое"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </Labeled>
        <Labeled label="Символьный код">
          <TextInput label="" source="symbolCode" validate={CheckCodeValue} />
        </Labeled>
        <Labeled label="Список приложений">
          <ReferenceInput source="applicationId" reference="applications">
            <SelectInput
              label=""
              optionValue="id"
              optionText="name"
              source="name"
              validate={CheckApplicationValue}
            />
          </ReferenceInput>
        </Labeled>
      </SimpleForm>
    </Create>
  )
}

const ListToolbar = () => (
  <Stack
    direction="row"
    justifyContent="flex-start"
    alignItems="center"
    spacing={0}
    sx={{ ml: 2, mr: 2 }}
  >
    <FilterForm filters={postFilters} />
    <div>
      <SelectColumnsButton />
      <FilterButton filters={postFilters} />
    </div>
  </Stack>
)

const PostPagination = () => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
)

// Список полей фильтрации
const postFilters = [
  <TextInput label="Поиск" source="query" alwaysOn />,
  <TextInput label="Id" source="id" defaultValue="" />,
  <TextInput label="Название" source="name" defaultValue="" />,
  <TextInput label="Символьный код" source="symbolCode" defaultValue="" />,
  <DateInput label="настройки" source="settings" />,
]
